export const environment = {
    production: false,    
    appURL: "https://api.teachmate.io/api/v1/user/",
    baseImageURL: "https://s3.ap-south-1.amazonaws.com/teachmate.io/"
};